import { Button } from './Button';

// The action cluster every venue-management list row ends with. Two labelled
// actions, and no more: the row's name already links to the detail page, so
// there is no View button, and status changes happen on the item's edit page
// rather than as colour-coded icon toggles in the list (#181, #349).
//
// Shared by the wines, events and tasting-experiences managers, which are
// otherwise three separate rows because their leading values and sub-lines
// carry different vocabulary.
interface ManagementRowActionsProps {
  itemId: string;
  /** Used to name the item in the buttons' accessible labels. */
  itemName: string;
  isDeleting: boolean;
  onEdit: (itemId: string) => void;
  onDelete: (itemId: string) => void;
}

export const ManagementRowActions = ({
  itemId,
  itemName,
  isDeleting,
  onEdit,
  onDelete,
}: ManagementRowActionsProps) => (
  <div className="flex flex-shrink-0 items-center gap-1">
    <Button
      variant="ghost"
      size="sm"
      onClick={() => onEdit(itemId)}
      aria-label={`Edit ${itemName}`}
    >
      Edit
    </Button>
    <Button
      variant="dangerGhost"
      size="sm"
      onClick={() => onDelete(itemId)}
      disabled={isDeleting}
      loading={isDeleting}
      aria-label={`Delete ${itemName}`}
    >
      {isDeleting ? 'Deleting…' : 'Delete'}
    </Button>
  </div>
);
